import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LocalizationPipe } from '@abp/ng.core';
import { WrapUpDefinitionDto } from 'src/core/models/wrap-up-definition/wrap-up-definition.dto';
import { WrapUpDefinitionListComponent } from '../wrap-up-definition-list/wrap-up-definition-list.component';
import { WrapUpDefinitionFormDialogComponent } from '../wrap-up-definition-form-dialog/wrap-up-definition-form-dialog.component';

@Component({
  selector: 'app-wrap-up-definition-main',
  standalone: true,
  imports: [
    CommonModule,
    LocalizationPipe,
    WrapUpDefinitionListComponent,
    WrapUpDefinitionFormDialogComponent,
  ],
  templateUrl: './wrap-up-definition-main.component.html',
})
export class WrapUpDefinitionMainComponent {
  reloadVersion = 0;
  showDialog = false;
  selectedCodeId: number | null = null;
  selectedCodeIsPredefined = false;

  openAddDialog(): void {
    this.selectedCodeId = null;
    this.selectedCodeIsPredefined = false;
    this.showDialog = true;
  }

  openEditDialog(code: WrapUpDefinitionDto): void {
    this.selectedCodeId = code.id;
    this.selectedCodeIsPredefined = code.isPredefined;
    this.showDialog = true;
  }

  onDialogVisibilityChange(visible: boolean): void {
    this.showDialog = visible;

    if (!visible) {
      this.selectedCodeId = null;
      this.selectedCodeIsPredefined = false;
    }
  }

  onSaved(): void {
    this.selectedCodeId = null;
    this.reloadVersion++;
  }

  onDeleted(): void {
    this.reloadVersion++;
  }
}
